###
  Custom error renderer for bootstrap-validator
###

$ ->

  $('form').on 'invalid.bs.validator', (e) ->
    e.preventDefault()
    message = if _.isArray(e.detail) then e.detail.join('<br>') else e.detail
    $(e.relatedTarget).showError message

  $('form').on 'valid.bs.validator', (e) ->
    e.preventDefault()
    $(e.relatedTarget).clearMessage()